import ConfirmationModal from "../../components/confirmation-modal";
import Label from "../../components/label";
import Close from "../../components/svg/close";
import UserImg from "../../assets/images/user.png";
import Pencil from "../../components/svg/pencil";

export default function ProfilePicture(props) {
  const { isOpen, setIsOpen } = props;
  return (
    <ConfirmationModal isOpen={isOpen} className="min-w-[436px] min-h-[657px]">
      <ConfirmationModal.Body className="flex flex-col p-8">
        <div className="ml-auto" role="button" tabIndex={0} onClick={() => setIsOpen(false)}>
          <Close />
        </div>
        <img src={UserImg} className="w-[180px] h-[180px] mt-4 mx-auto" alt="user-profile" />
        <div className="flex space-x-3 mx-auto items-center mt-4 cursor-pointer">
          <Pencil className="text-[#393188]" />
          <Label className="mb-0 text-[#393188] text-[16px]" label="Change" />
        </div>
      </ConfirmationModal.Body>
    </ConfirmationModal>
  );
}
